import PlaceHolderImage from "../../assets/allcastles.jpg";
import FlagImage from "../../assets/lives.jpg";
import InfoImage from "../../assets/points.jpg";
import AudioImage from "../../assets/audios.jpg";

const rulesData = {
  goal: [
    {
      image: PlaceHolderImage,
      text: `Καλώς ήλθες στο παιχνίδι της Καστρόπολης! 
Είσαι ένας πολιορκητής και στόχος σου είναι να κατακτήσεις όσο το δυνατόν 
περισσότερα από τα κάστρα που εμφανίζονται στο χάρτη.  `,
    },
    {
      image: PlaceHolderImage,
      text: `Για να κατακτήσεις ένα 
κάστρο, ευτυχώς δε χρειάζεται να ματώσεις, όπως οι πολιορκητές πρόγονοί σου, πρέπει 
απλώς να απαντήσεις σωστά σε κάποιες ερωτήσεις για την ιστορία του. Και η ιστορία 
τους είναι τεράστια, αιώνων, καθώς από τις πύλες τους έχουν περάσει αρχαίοι Έλληνες, 
Ρωμαίοι, Βυζαντινοί, Φράγκοι, Ενετοί και Οθωμανοί.`,
    },
    
    
  ],
  points: [
    {
      image: InfoImage,
      text: "Δε φτάνει βέβαια να κατακτήσεις ένα κάστρο, πρέπει να συγκεντρώσεις και όσο το δυνατόν περισσότερους πόντους, ώστε να καταφέρεις να μπεις στο «πάνθεο» των πολιορκητών. Κάθε ερώτηση έχει μια αξία σε πόντους. Η σωστή απάντηση σου προσθέτει πόντους, η λανθασμένη σου αφαιρεί. ",
    },
    {
      image: InfoImage,
      text: "Σε κάθε κάστρο υπάρχουν εύκολες και δύσκολες ερωτήσεις, οι δύσκολες θα σου δώσουν διπλάσιους πόντους. Όταν κατακτήσεις ένα κάστρο, οι πόντοι που μάζεψες από τις ερωτήσεις σου διπλασιάζονται αν το κάστρο είχε τρεις ερωτήσεις, ήταν δηλαδή εύκολο, τριπλασιάζονται αν το κάστρο είχε έξι ερωτήσεις, ήταν δηλαδή δύσκολο. ",
    },
    
  ],
  lives: [
    {
      image: FlagImage,
      text: "Σε κάθε προσπάθεια να κατακτήσεις ένα κάστρο, έχεις τρεις ευκαιρίες, δηλαδή τρεις «ζωές». Κάθε λάθος απάντηση σου στερεί μια ζωή και αν τις χάσεις όλες, η πολιορκία σου απέτυχε, έχασες το Κάστρο. ",
    },
    {
      image: FlagImage,
      text: "Αν αποτύχεις σε τρεις πολιορκίες, το παιχνίδι τελειώνει! ",
    },
  ],
  audios: [
    {
      image: AudioImage,
      text: "Πριν εμφανιστούν οι ερωτήσεις του κάθε κάστρου, σου δίνεται η ευκαιρία να ακούσεις μια αφήγηση για την ιστορία του. Εκεί βρίσκονται και οι σωστές απαντήσεις στις ερωτήσεις που θα σου γίνουν. Προσοχή όμως: όσο περισσότερη ώρα ακούς την αφήγηση, τόσο μειώνεται η αξία της κάθε ερώτησης, άρα και οι βαθμοί που θα κερδίσεις. ",
    },
    
  ],
};

export default rulesData;
